




















































import {
  Component,
  Prop,
  Vue,
  Provide,
  Watch,
  Emit,
} from 'vue-property-decorator';
import { ClassLogo } from './icons';
import UserBar from './_UserBar.vue';
import ActionBar from './_ActionBar.vue';
import MenuItem from './_MenuItem.vue';
import { IMenuBar, IMenuItemsWrapper } from '.';

@Component({
  components: {
    ClassLogo,
    UserBar,
    MenuItem,
    ActionBar,
  },
})
export default class AxNavbar extends Vue {
  @Provide() public menuState: {
    activeIndex: number | null;
    menuIsOpen: boolean;
    userIsOpen: boolean;
    helpIsOpen: boolean;
  } = {
    activeIndex: null,
    menuIsOpen: false,
    userIsOpen: false,
    helpIsOpen: false,
  };

  @Prop({ required: true }) public username: string;
  @Prop({ required: true }) public menuBar: IMenuBar;
  @Prop({ required: false }) public eventsMenuBar: IMenuBar;
  @Prop({ default: '' }) public baseUrl: string;
  @Prop({ default: '' }) public homeUrl: string;
  @Prop({ default: '' }) public clientViewPath: string;
  @Prop({ default: '' }) public classAgent: any;

  @Provide() public events: IMenuItemsWrapper = { menuItems: [] };

  @Watch('eventsMenuBar', { deep: true })
  updateEvents(val: IMenuBar) {
    this.events.menuItems = val?.menus?.[0].menuItems || [];
  }

  public get scopeIsFund(): boolean {
    return !!this.menuBar.code && this.menuBar.code.toLowerCase() === 'fund';
  }

  public get secondLevelIsOpen(): boolean {
    return this.menuState.menuIsOpen;
  }

  public toggleSecondLevelOpen(): void {
    Vue.set(this.menuState, 'menuIsOpen', !this.menuState.menuIsOpen);
    Vue.set(this.menuState, 'userIsOpen', false);
    Vue.set(this.menuState, 'helpIsOpen', false);
  }

  public setActiveItemIndex(index: number): void {
    Vue.set(this.menuState, 'activeIndex', index);
  }

  public closeAll(): void {
    Vue.set(this.menuState, 'menuIsOpen', false);
    Vue.set(this.menuState, 'userIsOpen', false);
    Vue.set(this.menuState, 'helpIsOpen', false);
  }

  public onClickOutside(e: Event) {
    const targetRefAxNavBar = this.$refs.axNavbar as HTMLElement;
    const eventTarget = e.target as HTMLElement;
    if (
      !(
        targetRefAxNavBar?.contains(eventTarget) ||
        eventTarget?.shadowRoot?.contains(targetRefAxNavBar)
      )
    ) {
      this.closeAll();
    }
  }

  @Emit('newFeatureToggled')
  public toggleNewFeature(e: Event) {
    const target = e.target as HTMLInputElement;
    return { newValue: target.checked };
  }

  @Emit('navigate') public navigate(e: Event) {
    return e;
  }

  public mounted() {
    this.updateEvents(this.eventsMenuBar);
    window.addEventListener('click', this.onClickOutside);
  }

  public destroyed() {
    window.removeEventListener('click', this.onClickOutside);
  }
}
